import React from 'react'
import isEqual from 'lodash/isEqual'
import { connect } from 'react-redux'
import { hasRead } from 'selectors/authSelectors'
import { getQuery } from 'selectors/pageStateSelectors'
import { getLeadSummaries } from 'selectors/leadSelectors'
import { getLeads } from 'actions/leadActions'
import { pushRooftopRoute, addToPageState } from 'actions/pageStateActions'
import { getRooftopZipcode } from 'selectors/appStatusSelectors'
import { getSelectedDateRange } from 'selectors/leadSelectors'
import CollectionFilterWrapper from 'discada/dist/CollectionFilterWrapper'
import { dateOptions } from 'utils'

import LeadHeader from 'components/Lead/LeadHeader'
import DateRangeSelector from 'components/widgets/DateRangeSelector'
import { get } from 'lodash'
import {
  FBI_FILTERS,
  LEAD_FILTERS,
  LEAD_STATS,
  SORT_OPTIONS,
  CHERRY_PICK_BUTTONS,
  generateLeadSwitches,
  generateReactionToggles,
  leadSearch,
} from 'components/Lead/util'

import './LeadList.scss'

export class LeadList extends React.Component {
  constructor(props) {
    super(props)
    const { queryParams } = props
    let { jsonFilters } = queryParams

    if (jsonFilters && typeof jsonFilters === 'string') {
      jsonFilters = JSON.parse(jsonFilters)
    }

    this.state = {
      jsonFilters: {
        ...jsonFilters,
        sortName: 'cherry',
        reverseSort: false,
      },
    }
  }

  componentDidMount() {
    this.props.getLeads()
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.selectedDateRange, this.props.selectedDateRange))
      this.props.getLeads()
  }

  render() {
    const { label, duringLabel } = get(
      dateOptions,
      this.props.selectedDateRange,
      {},
    )
    let {
        leadSummaries,
        pushRooftopRoute,
        isFbi,
        rooftopZip,
        addToPageState,
      } = this.props,
      switches = generateLeadSwitches(duringLabel || label, rooftopZip),
      textBubbleToggles = generateReactionToggles(
        leadSummaries.map(sum => sum.intent || []).flat(Infinity),
      ),
      filters = isFbi ? [...LEAD_FILTERS, ...FBI_FILTERS] : LEAD_FILTERS

    const onFilterChange = filterState => {
      let jsonFilters = JSON.stringify(filterState)

      this.setState({ jsonFilters }, () =>
        addToPageState({
          jsonFilters,
        }),
      )
    }

    return (
      <CollectionFilterWrapper
        externalControls={
          <DateRangeSelector
            size="small"
            ns="leads"
            selectedDateRange={this.props.selectedDateRange}
          />
        }
        className="gg-lead-list"
        countLabel="Cherry Leads"
        data={leadSummaries}
        searchPlaceholder="Type here to search"
        searchFilter={leadSearch}
        filters={filters}
        preSelectedOpts={this.state.jsonFilters}
        onFilterChange={onFilterChange}
        stats={LEAD_STATS}
        switches={switches}
        sortOptions={SORT_OPTIONS}
        toggles={[...CHERRY_PICK_BUTTONS, {}, ...textBubbleToggles]}
      >
        {({ data, stats }) => {
          return (
            <>
              {data.length === 0 && (
                <>
                  <h2 style={{ fontSize: '2em' }}>Nothing here...</h2>
                  <p>
                    Try turning off some filters or expanding the timerange...
                  </p>
                </>
              )}
              {data.map(x => (
                <div
                  key={x.id}
                  onClick={() => pushRooftopRoute(`lead/${x.id}`)}
                >
                  <LeadHeader id={x.id} collectionStats={stats} />
                </div>
              ))}
            </>
          )
        }}
      </CollectionFilterWrapper>
    )
  }
}

function mapStateToProps(state, op) {
  let isFbi = hasRead(state, 'rooftop.leads/list-advanced-filters')

  return {
    ...op,
    isFbi,
    selectedDateRange: getSelectedDateRange(state),
    leadSummaries: getLeadSummaries(state),
    rooftopZip: getRooftopZipcode(state),
    queryParams: getQuery(state),
  }
}

export default connect(
  mapStateToProps,
  { getLeads, pushRooftopRoute, addToPageState },
)(LeadList)
